import React, {useEffect, useState} from "react";
import {Typography, Link, Box} from "@mui/material";
import {Highlight, VideoUpdatableFields} from '../../../types/clipTypes'
import {formatDuration, formatUTCDate} from "../../../utils/dateTimeutils";
import {useTheme} from "../../../contexts/theme";
import {findClipDescription} from "../../../utils/utils";
import DeleteIcon from "@mui/icons-material/Delete";
import VideoContentTags from "../../CommonComponents/VideoContentTags/VideoContentTags";
import HighlightType from "../../CommonComponents/HighlightType/HighlightType";

interface HighlightListProps{
    highlight: Highlight
    onHighlightImageClick?: (highlight: Highlight) => void;
    onHighlightTitleClick?: (highlight: Highlight) => void;
    onHighlightDeleteClick?: (highlight: Highlight) => void;
    onHighlightContentUpdate?: (videoContentId: string, field: VideoUpdatableFields, value: string[] | string) => void;
    clipDeleting?: boolean;
}

const HighlightListElem: React.FC<HighlightListProps> = ({onHighlightContentUpdate = () => {}, clipDeleting, onHighlightDeleteClick = () => {}, highlight, onHighlightTitleClick= () =>{}, onHighlightImageClick = () => {}}) => {
    const theme = useTheme();
    const [defaultDescription, setDefaultDescription] = useState<string>("")
    const [localDelete, setLocalDelete] = useState<boolean>(false)

    useEffect(() => {
        setDefaultDescription(findClipDescription(highlight))
    }, [highlight]);

    /*
    useEffect(() => {
        console.log("clip", clip.title)
    }, [clip]);

    useEffect(() => {
        console.log("setMoreInfoClip", clip.title)
    }, [setMoreInfoClip]);

    useEffect(() => {
        console.log("moreInfoOpen", clip.title)
    }, [moreInfoOpen]);

    useEffect(() => {
        console.log("noMarginTop", clip.title)
    }, [noMarginTop]);

    useEffect(() => {
        console.log("onClipTitleClick", clip.title)
    }, [onClipTitleClick]);

    useEffect(() => {
        console.log("onClipImageClick", clip.title)
    }, [onClipImageClick]);

    useEffect(() => {
        console.log("displayMoreInfoIcon", clip.title)
    }, [displayMoreInfoIcon]);
     */

    return (
        <Box
            sx={{
                display: 'flex',
                paddingBottom: theme.spacing.sm,
                borderBottom: `${theme.border.type.solid} ${theme.border.width.thin} ${theme.palette.lightGrey}`,
                position:'relative',
            }}>

            {clipDeleting && localDelete && <Box
                width={'100%'}
                height={'100%'}
                sx={{backgroundColor:theme.palette.blurredBlue}}
                top={'0'}
                left={'0'}
                position={'absolute'}
                zIndex={99}
            ></Box>}

            <Box position={'relative'}>
                <img alt="Clip thumbnail" style={{width: '180px', height: 'auto'}} src={highlight.thumbnail} onClick={() => onHighlightImageClick(highlight)}/>
                <DeleteIcon
                    fontSize={'small'}
                    onClick={(event) => {setLocalDelete(true);onHighlightDeleteClick(highlight)}}
                    sx={{position: 'absolute', top:0, right: 0, color: theme.palette.white}}
                />
                {highlight.type && highlight.type !== 'Regular' &&
                    <Box padding={theme.spacing.xs} width={'100%'} position={'absolute'} top={0} left={0}>
                        <HighlightType highlight_type={highlight.type}/>
                    </Box>
                }
            </Box>
            <Box sx={{paddingLeft: theme.spacing.md, marginBottom: theme.spacing.xs, height:'100%', flex: 1}}>
                <Box sx={{display: 'flex', justifyContent: 'space-between', width:'100%'}}>
                    <Link fontSize={theme.fontSizes.subParagraphTitle} fontWeight={theme.fontWeights.subParagraphTitle} onClick={() => onHighlightTitleClick(highlight)}>{highlight.title}</Link>
                </Box>
                <Typography
                    fontSize={theme.fontSizes.subParagraphText}
                    fontWeight={theme.fontSizes.subParagraphText}
                    sx={{marginBottom: theme.spacing.xs}}
                >
                    { defaultDescription }
                </Typography>
                <Box sx={{marginBottom: theme.spacing.xs}}>
                    <Typography component={'span'} fontSize={theme.fontSizes.subParagraphText} fontWeight={theme.fontSizes.subParagraphText}>Duration: </Typography>
                    <Typography component={'span'} fontSize={theme.fontSizes.subParagraphText} fontWeight={theme.fontSizes.subParagraphTitle}>{formatDuration(highlight.duration)}</Typography>
                </Box>
                {highlight.created_at && <Box sx={{marginBottom: theme.spacing.xs}}>
                    <Typography component={'span'} fontSize={theme.fontSizes.subParagraphText} fontWeight={theme.fontSizes.subParagraphText}>Created at: </Typography>
                    <Typography component={'span'} fontSize={theme.fontSizes.subParagraphText} fontWeight={theme.fontSizes.subParagraphTitle}>{formatUTCDate(highlight.created_at)}</Typography>
                </Box>}
                <VideoContentTags
                    tags={highlight.tags ? highlight.tags : []}
                    contentType={'clip'}
                    label={'Tags:'}
                    onTagSelected={(tags) => onHighlightContentUpdate(highlight.id, 'tags', tags)}
                    labelStyle={{
                        fontSize:theme.fontSizes.subParagraphText,
                        fontWeight:theme.fontSizes.subParagraphText,
                        color:theme.palette.lightGrey,
                        marginRight: theme.spacing.xs
                    }}
                />
            </Box>
        </Box>
    );
};

export default React.memo(HighlightListElem);